// components
import { ReactSVG } from 'react-svg';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const getIcon = (icon) => <ReactSVG src={`/icons/${icon}.svg`} style={{ width: 22, height: 22 }} />;

const ICONS = {
  dashboard: getIcon('dashboard'),
  campaign: getIcon('campaign'),
  report: getIcon('receipt-search'),
  serp: getIcon('search-status'),
  setting: getIcon('setting-2'),
  help: getIcon('lifebuoy'),
  logout: getIcon('logout'),
  threads: getIcon('arrow'),
};

const navConfig = [
  {
    subheader: '',
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.analytics,
        icon: ICONS.dashboard,
      },
      {
        title: 'Campaigns',
        path: PATH_DASHBOARD.campaigns.list,
        icon: ICONS.campaign,
      },
      {
        title: 'Campaigns overview',
        path: PATH_DASHBOARD.campaigns.overview(''),
        icon: ICONS.campaign,
        hide: true,
      },
      {
        title: 'Logs',
        path: PATH_DASHBOARD.reports,
        icon: ICONS.report,
      },

      // {
      //   title: 'SERP Checker',
      //   path: PATH_DASHBOARD.serp,
      //   icon: ICONS.serp,
      // },
    ],
  },
  {
    subheader: '',
    items: [
      {
        title: 'Settings',
        path: PATH_DASHBOARD.settings,
        icon: ICONS.setting,
      },
      {
        title: 'Threads',
        path: PATH_DASHBOARD.threads,
        icon: ICONS.threads,
      },
      {
        title: 'About',
        path: PATH_DASHBOARD.about,
        icon: ICONS.serp,
      },
      {
        title: 'Help',
        type: 'tour-guide',
        icon: ICONS.help,
      },
      // {
      //   title: 'Log out',
      //   path: PATH_DASHBOARD.logout,
      //   icon: ICONS.logout,
      // },
    ],
  },
];

export default navConfig;
